import { Page } from '../../types'

const civilProsecutionsBribery: Page[] = [
    {
        pageType: 'question',
        title: 'Civil prosecutions for bribery',
        name: 'civil-prosecutions-bribery',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were referred?',
                name: 'civil-prosecutions-bribery-referred',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions proceeded to charge?',
                name: 'civil-prosecutions-bribery-proceeded',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were successful?',
                name: 'civil-prosecutions-bribery-successful',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default civilProsecutionsBribery
